<script setup>
import { ref, reactive, onMounted, nextTick } from 'vue'
// import LayoutHeaderUl from './LayoutHeaderUl.vue'
// vueUse useScroll: 获取当前页面滚动了多少
import { useScroll } from '@vueuse/core'
import headerView from '@/components/headerView/index.vue';
import { useRouter } from 'vue-router'
const router = useRouter()
const currentRoute = ref(router.currentRoute.value.path);
// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        currentRoute.value = newPath;
        if(currentRoute.value=='/'){
            ydata.value=-1
        }else{
            ydata.value=78
        }
    }
);
// 封装请求
import { useCategoryStore } from '@/stores/categoryStore';

// 纵向滚动的距离
const { y } = useScroll(window)

const ydata=ref(-1)
const content = ref()


</script>

<template>
    <div  class="app-header-sticky" :class="{show: y > 78}">
        <headerView></headerView>
    </div>
    <!-- <div v-else class="app-header-sticky" :class="{show: y > -1}">
        <headerView></headerView>
    </div> -->
</template>


<style scoped lang='scss'>
.app-header-sticky {
    background-color: #ffffff4d !important;
    backdrop-filter: saturate(180%) blur(10px);
    display: flex;
    width: 100%;
    height: 70px;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
    background-color: #fff;
    // border-bottom: 1px solid #e4e4e4;
    // 此处为关键样式!!!
    // 状态一：往上平移自身高度 + 完全透明
    transform: translateY(-100%);
    // 透明度 0 => 全透明
    opacity: 0;

    // 状态二：移除平移 + 完全不透明
    &.show {
        transition: all 0.3s linear;
        transform: none;
        opacity: 1;
    }

    .container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    // .logo {
    //     width: 200px;
    //     height: 80px;
    //     background: url("@/assets/images/logo.png") no-repeat right 2px;
    //     background-size: 160px auto;
    // }

    .right {
        width: 220px;
        display: flex;
        text-align: center;
        padding-left: 40px;
        border-left: 2px solid $xtxColor;

        a {
            width: 38px;
            margin-right: 40px;
            font-size: 16px;
            line-height: 1;

            &:hover {
                color: $xtxColor;
            }
        }
    }
}


</style>